import React, { useState } from 'react';
import styles from './OffersPopUp.module.css';
import { putHistory } from '../../api/Client/history';
import { useNavigate } from 'react-router-dom';

const Client = ({ popUp, history, merchant }) => {
    const [code, setCode] = useState('');
    const [valid, setValid] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    async function handleBtn(e) {
        e.preventDefault();

        if (code.trim().toUpperCase() === merchant.traderCode.toUpperCase()) {
            if (!history?.history_data) {
                await putHistory(new Date().getMonth() + 1, popUp.id.toString(), navigate);
            } else {
                const newHistory = history.history_data + '-' + popUp.id;
                await putHistory(new Date().getMonth() + 1, newHistory, navigate);
            }
            setValid(true);
        } else {
            setError('Ce code commerçant n\'est pas le bon.');
        }
    }


    return (
        <>
            {!valid && (
                <>
                    <h1 className={styles.title}>Votre offre est prête 🎉</h1>
                    <p className={styles.subtitle}>
                        Merci de demander à l’établissement d’entrer son code pour activer votre avantage !!!
                    </p>

                    <input
                        className={styles.codebadge}
                        placeholder='_ _ _ _'
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        maxLength={4}
                    />
                    {error && <p style={{color: 'red', margin: '0'}}>{error}</p>}
                    <button onClick={handleBtn} className={styles.btn}>
                        Souscrire à l'offre
                    </button>
                </>
            )}

            {valid && (
                <>
                    <h1 className={styles.title}>Votre offre est validée ✅</h1>
                    <p className={styles.subtitle}>
                        Vous venez de souscrire à l'offre <strong>{popUp.title}</strong> du commerçant <strong>{merchant.company}</strong>
                    </p>
                </>
            )}
        </>
    );
};

export default Client;
